import { SubmissionError } from "redux-form";
import fetch from "../../core/fetch";
import { getListingDataStep3 } from "../../actions/getListingDataStep3";
import { manageListingSteps } from "../../actions/manageListingSteps";
import { setLoaderStart, setLoaderComplete } from "../../actions/loader/loader";
import history from "../../core/history";
import messages from "../../locale/messages";

async function updateStep3(values, dispatch) {
  dispatch(setLoaderStart("updateListing"));

  try {
    // ✅ 1. Fetch globleListTax from getServiceFees
    const taxResp = await fetch("/graphql", {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        query: `
          query {
            getServiceFees {
              globleListTax
            }
          }
        `,
      }),
      credentials: "include",
    });

    const taxResult = await taxResp.json();
    const fetchedTax = taxResult?.data?.getServiceFees?.globleListTax || 0;

    // ✅ 2. Extract and normalize all values
    const id = values?.id ? Number(values.id) : null;
    const houseRules = values?.houseRules || [];
    const bookingNoticeTime =
      values?.bookingNoticeTime !== undefined
        ? String(values.bookingNoticeTime)
        : "";
    const checkInStart = values?.checkInStart || "Flexible";
    const checkInEnd = values?.checkInEnd || "Flexible";
    const maxDaysNotice =
      values?.maxDaysNotice !== undefined ? String(values.maxDaysNotice) : "";
    const minNight = values?.minNight ? parseInt(values.minNight) : 0;
    // const maxNight = values?.maxNight ? parseInt(values.maxNight) : 0;
    
    let maxNight;
    if (values?.maxNight === true || values?.maxNight === "true") {
      maxNight = 9999;
    } else {
      maxNight = values?.maxNight ? parseInt(values.maxNight) : 0;
    }

    const basePrice = values?.basePrice ? parseFloat(values.basePrice) : 0;
    const cleaningPrice = values?.cleaningPrice
      ? parseFloat(values.cleaningPrice)
      : 0;
    const currency = values?.currency || "";
    const blockedDates = values?.blockedDates || [];
    const bookingType = values?.bookingType || "";
    const cancellationPolicy = values?.cancellationPolicy
      ? Number(values.cancellationPolicy)
      : 1;
    const weeklyDiscount = values?.weeklyDiscount
      ? parseInt(values.weeklyDiscount)
      : 0;
    const monthlyDiscount = values?.monthlyDiscount
      ? parseInt(values.monthlyDiscount)
      : 0;

    const allowLongStay = values?.allowLongStay ? 1 : 0;
    // ✅ 3. Use fetched globleListTax
    const variables = {
      id,
      houseRules,
      bookingNoticeTime,
      checkInStart,
      checkInEnd,
      maxDaysNotice,
      minNight,
      maxNight,
      basePrice,
      cleaningPrice,
      tax: fetchedTax,
      currency,
      weeklyDiscount,
      monthlyDiscount,
      blockedDates,
      bookingType,
      cancellationPolicy,
      allowLongStay,
    };

    const mutationQuery = `query (
      $id: Int,
      $houseRules: [Int],
      $bookingNoticeTime: String,
      $checkInStart: String,
      $checkInEnd: String,
      $maxDaysNotice: String,
      $minNight: Int,
      $maxNight: Int,
      $basePrice: Float,
      $cleaningPrice: Float,
      $tax: Float,
      $currency: String,
      $weeklyDiscount: Int,
      $monthlyDiscount: Int,
      $blockedDates: [String],
      $bookingType: String!,
      $cancellationPolicy: Int,
      $allowLongStay: Int
    ) {
      updateListingStep3 (
        id: $id,
        houseRules: $houseRules,
        bookingNoticeTime: $bookingNoticeTime,
        checkInStart: $checkInStart,
        checkInEnd: $checkInEnd,
        maxDaysNotice: $maxDaysNotice,
        minNight: $minNight,
        maxNight: $maxNight,
        basePrice: $basePrice,
        cleaningPrice: $cleaningPrice,
        tax: $tax,
        currency: $currency,
        weeklyDiscount: $weeklyDiscount,
        monthlyDiscount: $monthlyDiscount,
        blockedDates: $blockedDates,
        bookingType: $bookingType,
        cancellationPolicy: $cancellationPolicy,
        allowLongStay: $allowLongStay
      ) {
        status
      }
    }`;

    const resp = await fetch("/graphql", {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        query: mutationQuery,
        variables,
      }),
      credentials: "include",
    });

    const { data } = await resp.json();

    if (data?.updateListingStep3?.status === "success") {
      await dispatch(manageListingSteps(id, 3));
      history.push(`/become-a-host/${id}/home`);
      await dispatch(getListingDataStep3(id));
      dispatch(setLoaderComplete("updateListing"));
    } else if (data?.updateListingStep3?.status === "notLoggedIn") {
      dispatch(setLoaderComplete("updateListing"));
      throw new SubmissionError({ _error: messages.notLoggedIn });
    } else {
      dispatch(setLoaderComplete("updateListing"));
      throw new SubmissionError({ _error: messages.somethingWentWrong });
    }
  } catch (error) {
    dispatch(setLoaderComplete("updateListing"));
    throw new SubmissionError({ _error: messages.somethingWentWrong });
  }
}

export default updateStep3;
